<template>
	<div class="row flex-row">
		<div v-for="item in items" :key="item.ID" class="columns column4">
			<div class="promotion">
				<nuxt-link :to="localePath(`/${item.filename}`)">
					<picture class="image">
						<source :srcset="item.overviewImageWebp" type="image/webp" />
						<source :srcset="item.overviewImage" />
						<img :src="item.overviewImage" :alt="item.overviewImageAlt" loading="lazy" />
					</picture>
				</nuxt-link>
				<div class="content">
					<h4>
						<nuxt-link :to="localePath(`/${item.filename}`)">
							{{ item.header }}
						</nuxt-link>
					</h4>
					<p>{{ item.overviewContent }}</p>
					<nuxt-link :to="localePath(`/${item.filename}`)" class="button">
						{{ $t('viewThisPackage') }}
					</nuxt-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	items: { type: Array, default: () => [] },
});
</script>

<style lang="scss" scoped>
.columns {
	display: flex;
}

.promotion {
	background-color: var(--primary-background-color);
	display: flex;
	flex-flow: column;
	margin: 0 auto 20px;
	position: relative;
	box-shadow: 0 0 10px rgb(0 0 0 / 5%);

	&:hover a img {
		transform: scale(1.03);
	}

	a {
		color: #000;
		text-decoration: none;
	}

	.image {
		width: 100%;
		display: block;
		overflow: hidden;

		img {
			width: 100%;
			transition: all 0.3s ease-in-out;
		}
	}

	.content {
		flex: 1;
		padding: 40px 40px 90px;

		.button {
			position: absolute;
			bottom: 30px;
			left: 30px;
			color: #fff;
		}
	}
}
</style>
